/* Story scroll — scroll-progress-driven image pan.
   Scoped per section instance; cleans up on theme-editor re-render. */
(function () {
  'use strict';

  var instances = new Map();

  function StoryScroll(root) {
    this.root = root;
    this.blocks = Array.prototype.slice.call(root.querySelectorAll('[data-story-block]'));
    this.active = new Set();
    this.raf = null;
    this.mqNarrow = window.matchMedia('(max-width: 899px)');
    this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var self = this;
    this.onScroll = function () { self.schedule(); };

    // Only pan blocks near the viewport
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) self.active.add(e.target);
        else self.active.delete(e.target);
      });
      self.schedule();
    }, { rootMargin: '20% 0px' });
    this.blocks.forEach(function (b) { self.io.observe(b); });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.schedule();
  }

  StoryScroll.prototype.schedule = function () {
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function () {
      self.raf = null;
      self.update();
    });
  };

  StoryScroll.prototype.update = function () {
    if (this.mqNarrow.matches || this.mqReduce.matches) return; // CSS handles static fallback
    var vh = window.innerHeight;
    this.active.forEach(function (block) {
      var wrap = block.querySelector('[data-sticky-wrap], .story-scroll__sticky');
      var img = block.querySelector('[data-pan-img], .story-scroll__img');
      if (!wrap || !img) return;
      var rect = block.getBoundingClientRect();
      var range = rect.height - vh;
      if (range <= 0) return;
      var progress = Math.min(1, Math.max(0, -rect.top / range));
      var travel = img.offsetHeight - wrap.offsetHeight;
      if (travel <= 0) return;
      img.style.transform = 'translateY(' + (-progress * travel).toFixed(1) + 'px)';
    });
  };

  StoryScroll.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    this.io.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-story-scroll]').forEach(function (root) {
      if (!instances.has(root)) instances.set(root, new StoryScroll(root));
    });
  }

  function destroy(scope) {
    (scope || document).querySelectorAll('[data-story-scroll]').forEach(function (root) {
      var inst = instances.get(root);
      if (inst) { inst.destroy(); instances.delete(root); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
